import React from "react";
import { Icon, IconButton, IconButtonProps } from "@chakra-ui/react";
import { FiSun, FiMoon } from "react-icons/fi";
import { useTheme } from "../context/ThemeContext";
import type { IconType } from "react-icons";

interface ToggleColorModeButtonProps {
  iconButtonProps?: Omit<IconButtonProps, "aria-label">;
  width?: string | number;
  height?: string | number;
}

export const ToggleColorModeButton: React.FC<ToggleColorModeButtonProps> = ({
  iconButtonProps,
  width,
  height,
}) => {
  const { isDarkMode, toggleTheme } = useTheme();

  const label = isDarkMode ? "Switch to light mode" : "Switch to dark mode";
  const IconComponent: IconType = isDarkMode ? FiMoon : FiSun;

  const handleToggle = (): void => {
    toggleTheme();
  };

  return (
    <IconButton
      isRound
      aria-label={label}
      icon={<Icon as={IconComponent as any} w={width} h={height} />}
      onClick={handleToggle}
      {...(iconButtonProps as any)}
    />
  );
};
